/* eslint-disable no-console */
import { Amplify } from 'aws-amplify'

import { getCentralizedCognitoPoolConfig } from './pool-configs'

const DEBUG = process.env.NODE_ENV === 'development'

export const initAmplify = () => {
  const config = getCentralizedCognitoPoolConfig()
  Amplify.configure(config)
  /* eslint-disable-next-line no-unused-expressions */
  DEBUG && console.log('[Amplify] initAmplify initialized with:', { config })
}

export * from './auth'
